export default "/_next/static/chunks/fonts/HK Grotesk Extra Bold Italic-1a2a161ee17afbb928f714dc1a2279f1.otf";